export const HOWIE_PRACTICE_COMPLETED_EVENT = 'howie:practice-completed';
